import {
  DialogContent,
  DialogTitle,
  Fade,
  Paper,
  Popper,
  Typography
} from '@mui/material';

import { popperUtil } from 'modules/common';



export type CalculationSentimentSummaryPopperProps = popperUtil.IBasePopperProps & {
  summary: string;
};

export const FC = (props: CalculationSentimentSummaryPopperProps) => {
  return (
    <Popper
      open={props.open}
      anchorEl={props.anchorEl}
      onMouseLeave={props.handleClose}
      transition
      sx={{
        maxWidth: '50vw',
        zIndex: 1_000_000
      }}
    >
      {({ TransitionProps }) => (
        <Fade
          {...TransitionProps}
          timeout={350}
        >
          <Paper>
            <DialogTitle>
              Sherlocks Sentiment Analysis
            </DialogTitle>

            <DialogContent>
              <Typography variant='h4Heavy'>
                {props.summary}
              </Typography>
            </DialogContent>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};
